// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Estilos específicos para Ident/* Estilos para los radio buttons SI/NO */
.radio-si-no {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
  min-width: 80px;
}

.si-no-label {
  font-size: 0.875rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  text-align: center;
  color: #495057;
}

.radio-buttons-row {
  display: flex;
  gap: 0.75rem;
  align-items: center;
  justify-content: center;
}

.radio-option {
  display: flex;
  align-items: center;
  font-size: 0.875rem;
  font-weight: 500;
}

.radio-option input[type='radio'] {
  margin-right: 0.25rem;
}

.radio-option span {
  color: #495057;
}
s de Entorno */ .observaciones-container {
  border: 2px solid #dee2e6;
  border-radius: 8px;
  background-color: white;
}

.observaciones-container h6 {
  color: #495057;
  font-weight: 600;
  margin-bottom: 1rem;
}

.observaciones-text-area textarea {
  border: 1px solid #ced4da;
  border-radius: 4px;
  resize: vertical;
  min-height: 100px;
}

.observaciones-text-area textarea:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.observaciones-text-area textarea:disabled {
  background-color: #f8f9fa;
  border-color: #e9ecef;
  color: #6c757d;
  opacity: 1;
}

/* Estilos para los radio buttons SI/NO */
.radio-si-no {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
}

.radio-si-no input[type='radio'] {
  margin-right: 0.25rem;
}

.radio-si-no > div {
  display: flex;
  align-items: center;
  font-size: 0.875rem;
  font-weight: 600;
}

/* Estilos para la tabla de peligros de entorno */
.table-peligros-entorno th {
  background-color: #e9ecef;
  font-weight: 600;
  font-size: 0.875rem;
  text-align: center;
  vertical-align: middle;
  padding: 0.75rem 0.5rem;
}

.table-peligros-entorno td {
  vertical-align: middle;
  font-size: 0.875rem;
  padding: 0.75rem 0.5rem;
}

/* Columna SI/NO más estrecha */
.table-peligros-entorno .si-no-column {
  width: 80px;
  min-width: 80px;
  max-width: 80px;
}

/* Columna de acciones más estrecha */
.table-peligros-entorno .acciones-column {
  width: 100px;
  min-width: 100px;
  max-width: 100px;
}

/* Estilo específico para el título de sección */
.identificacion-peligros-title {
  color: #495057;
  font-weight: 600;
  font-size: 1.25rem;
  margin-bottom: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/modules/Pages/Solicitud/AnalisisRiesgo/IdentificacionPeligrosEntorno/styles.css"],"names":[],"mappings":"AAAA,0EAA0E;AAC1E;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,UAAU;AACZ;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,iDAAiD;AACjD;EACE,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,+BAA+B;AAC/B;EACE,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA,qCAAqC;AACrC;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,gDAAgD;AAChD;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB","sourcesContent":["/* Estilos específicos para Ident/* Estilos para los radio buttons SI/NO */\n.radio-si-no {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 0.5rem;\n  min-width: 80px;\n}\n\n.si-no-label {\n  font-size: 0.875rem;\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n  text-align: center;\n  color: #495057;\n}\n\n.radio-buttons-row {\n  display: flex;\n  gap: 0.75rem;\n  align-items: center;\n  justify-content: center;\n}\n\n.radio-option {\n  display: flex;\n  align-items: center;\n  font-size: 0.875rem;\n  font-weight: 500;\n}\n\n.radio-option input[type='radio'] {\n  margin-right: 0.25rem;\n}\n\n.radio-option span {\n  color: #495057;\n}\ns de Entorno */ .observaciones-container {\n  border: 2px solid #dee2e6;\n  border-radius: 8px;\n  background-color: white;\n}\n\n.observaciones-container h6 {\n  color: #495057;\n  font-weight: 600;\n  margin-bottom: 1rem;\n}\n\n.observaciones-text-area textarea {\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n  resize: vertical;\n  min-height: 100px;\n}\n\n.observaciones-text-area textarea:focus {\n  border-color: #007bff;\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n\n.observaciones-text-area textarea:disabled {\n  background-color: #f8f9fa;\n  border-color: #e9ecef;\n  color: #6c757d;\n  opacity: 1;\n}\n\n/* Estilos para los radio buttons SI/NO */\n.radio-si-no {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  align-items: center;\n  justify-content: center;\n  padding: 0.5rem;\n}\n\n.radio-si-no input[type='radio'] {\n  margin-right: 0.25rem;\n}\n\n.radio-si-no > div {\n  display: flex;\n  align-items: center;\n  font-size: 0.875rem;\n  font-weight: 600;\n}\n\n/* Estilos para la tabla de peligros de entorno */\n.table-peligros-entorno th {\n  background-color: #e9ecef;\n  font-weight: 600;\n  font-size: 0.875rem;\n  text-align: center;\n  vertical-align: middle;\n  padding: 0.75rem 0.5rem;\n}\n\n.table-peligros-entorno td {\n  vertical-align: middle;\n  font-size: 0.875rem;\n  padding: 0.75rem 0.5rem;\n}\n\n/* Columna SI/NO más estrecha */\n.table-peligros-entorno .si-no-column {\n  width: 80px;\n  min-width: 80px;\n  max-width: 80px;\n}\n\n/* Columna de acciones más estrecha */\n.table-peligros-entorno .acciones-column {\n  width: 100px;\n  min-width: 100px;\n  max-width: 100px;\n}\n\n/* Estilo específico para el título de sección */\n.identificacion-peligros-title {\n  color: #495057;\n  font-weight: 600;\n  font-size: 1.25rem;\n  margin-bottom: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
